import { http } from './httpClient';

// GET /api/web-settings/{businessId}
export function getWebSettingsByBusiness(businessId, { signal } = {}) {
    return http.get(`/api/web-settings/${businessId}`, undefined, { signal });
}

// GET /api/web-settings/by-branch/{branchId}
export function getWebSettingsByBranch(branchId, { signal } = {}) {
    return http.get(`/api/web-settings/by-branch/${branchId}`, undefined, { signal });
}
